import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, withLatestFrom, distinctUntilChanged } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { routerSelectors } from './router.selector';
import { TableFilterActions } from '../table-state/table-filter-state/table-filter.actions';

@Injectable()
export class RouterEffects {
    store: Store = inject(Store)

    clearFiltersOnInstallationChange$ = createEffect(() =>
        this.store.select(routerSelectors.selectInstallationRefCode).pipe(
            distinctUntilChanged(),
            map(() => TableFilterActions.removeAllFiltersFromInstallation())
        )
    );

}